module.exports = __webpack_public_path__ + "img/bg_light.7b9ebcd6.jpg";